var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.languages.length > 0)?_c('TabsStructure',{key:_vm.vkey,staticClass:"localizations-field",attrs:{"model":_vm.internalModel,"element":_vm.localizationTabElement}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }